export default {"src":"/_next/static/media/white-arrow-up.5fe3b34b.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};